import { Language, ProjectInfoType } from '../enum/EnumRepository';
import { useLanguageStore } from '../store/languageStore';

const PROJECT_INFO_TYPE_LABELS: Record<ProjectInfoType, Record<Language, string>> = {
  [ProjectInfoType.ACTIVE_DATE]: {
    [Language.EN]: 'Active Date',
    [Language.KR]: '날짜·기간',
  },
  [ProjectInfoType.LOCATION]: {
    [Language.EN]: 'Location',
    [Language.KR]: '장소',
  },
  [ProjectInfoType.CREDIT]: {
    [Language.EN]: 'Credit',
    [Language.KR]: '참여자·크레딧',
  },
  [ProjectInfoType.OTHER]: {
    [Language.EN]: 'Other',
    [Language.KR]: '기타',
  },
};

export const getProjectInfoTypeLabel = (type: ProjectInfoType): string => {
  const language = useLanguageStore.getState().language;
  const row = PROJECT_INFO_TYPE_LABELS[type];
  if (!row) {
    return String(type);
  }
  return row[language] ?? row[Language.EN];
};

const PROJECT_INFO_NAME_PLACEHOLDERS: Record<ProjectInfoType, Record<Language, string>> = {
  [ProjectInfoType.ACTIVE_DATE]: {
    [Language.EN]: 'Active Date',
    [Language.KR]: '날짜·기간',
  },
  [ProjectInfoType.LOCATION]: {
    [Language.EN]: 'Location',
    [Language.KR]: '장소',
  },
  [ProjectInfoType.CREDIT]: {
    [Language.EN]: 'Credit Info',
    [Language.KR]: '크레딧 정보',
  },
  [ProjectInfoType.OTHER]: {
    [Language.EN]: 'Other Info',
    [Language.KR]: '기타 정보',
  },
};

export const getProjectInfoNamePlaceholder = (type: ProjectInfoType): string => {
  const language = useLanguageStore.getState().language;
  const row = PROJECT_INFO_NAME_PLACEHOLDERS[type] ?? PROJECT_INFO_NAME_PLACEHOLDERS[ProjectInfoType.OTHER];
  return row[language] ?? row[Language.EN];
};

const PROJECT_INFO_VALUE_PLACEHOLDERS: Record<ProjectInfoType, Record<Language, string>> = {
  [ProjectInfoType.ACTIVE_DATE]: {
    [Language.EN]: 'e.g. 2024. 3. 1 – 2024. 5. 12',
    [Language.KR]: '예: 2024. 3. 1 – 2024. 5. 12',
  },
  [ProjectInfoType.LOCATION]: {
    [Language.EN]: 'e.g. Venue name, City, address, etc. (link a Venue)',
    [Language.KR]: '예: 장소명, 도시, 주소, 등 (장소를 연결할 수 있습니다)',
  },
  [ProjectInfoType.CREDIT]: {
    [Language.EN]: 'e.g. Collaborator, photographer, designer, curator, staff, etc.',
    [Language.KR]: '예: 협업자, 사진, 디자이너, 큐레이터, 스태프, 등',
  },
  [ProjectInfoType.OTHER]: {
    [Language.EN]: 'e.g. Sponsor, supporter, organizer, media partner, keyword',
    [Language.KR]: '예: 후원사, 지원, 주최, 미디어 파트너, 키워드',
  },
};

export const getProjectInfoValuePlaceholder = (type: ProjectInfoType): string => {
  const language = useLanguageStore.getState().language;
  const row = PROJECT_INFO_VALUE_PLACEHOLDERS[type];
  if (!row) {
    return PROJECT_INFO_VALUE_PLACEHOLDERS[ProjectInfoType.OTHER][language]
      ?? PROJECT_INFO_VALUE_PLACEHOLDERS[ProjectInfoType.OTHER][Language.EN];
  }
  return row[language] ?? row[Language.EN];
};
